import React from "react";
import { Helmet } from "react-helmet";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import DashboardLayout from "@/components/DashboardLayout";
import PageCallToAction from "@/components/PageCallToAction";

const Fulfillment = () => {
  return (
    <DashboardLayout>
      <div className="container mx-auto py-12 px-4">
        <Helmet>
          <title>Fulfillment Terms | OpenPipe</title>
        </Helmet>
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-3xl font-bold">
              Fulfillment Terms
            </CardTitle>
            <CardDescription>Last updated February 22, 2024</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p>
              This page provides the fulfillment terms for OpenPipe, Inc.
              ("Company," "we," "us," or "our") and describes how we charge for
              training and inference.
            </p>

            <h2>Training</h2>
            <p>
              OpenPipe charges for model training based on the architecture of
              the base model trained as well as the number of tokens the model
              will see during training. We provide an estimate of training costs
              at the time you start a model training job. This estimate is
              usually exactly right, but because of differences in the way
              tokenization is performed while preparing that estimate vs how it
              is done (in a more exact way) as part of the actual training job,
              the actual costs may differ.
            </p>

            <p>
              We will never charge more than 2x the estimated costs when
              calculating the final cost of a training run.
            </p>

            <h2>Inference</h2>
            <p>
              Model inference performed through the OpenPipe API will be charged
              at a per-token rate as shown on our pricing page. Pricing varies
              by model.
            </p>

            <h2>Credits</h2>
            <p>
              Accounts may be issued credits for promotional or service-related
              reasons. Credits will generally be applied to the next invoices
              generated after the credit is generated. It is also possible to
              refund an existing invoice in full or in part if an error was made
              while calculating the invoice amount.
            </p>

            <h2>Billing</h2>
            <p>
              Billing is performed on a monthly cycle. At the end of each
              calendar month, each project will be issued a bill for the
              inference and training expenses accrued during that month. The
              bill will automatically be charged to the credit card on file, or
              if no credit card is on file the project owner will be emailed the
              invoice. In all cases an email invoice will be generated and sent
              to the project owner for their records.
            </p>

            <h2>Denial of Service for Payment Reasons</h2>
            <p>
              OpenPipe reserves the right to deny service to any project that
              has a balance below 0 if no valid credit card is on file. OpenPipe
              can also deny service for payment reasons if an account's usage is
              substantially higher than in previous months and there is no
              explicit conversation explaining the increased usage.
            </p>

            <p>
              If you have any questions relating to payment or fulfillment of
              services, please contact us at{" "}
              <a href="mailto:support@openpipe.ai">support@openpipe.ai</a>.
            </p>
          </CardContent>
        </Card>

        <div className="mt-12">
          <PageCallToAction />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Fulfillment;
